import React, { useState, useEffect } from 'react';
import { useTheme } from 'styled-components';

import * as S from './styles';

const DecorativeDivider = () => {
  const theme = useTheme();
  const [Icon, setIcon] = useState(null);

  useEffect(() => {
    const getIcon = async () => {
      if (process.env.REACT_APP_ENV === 'cd') {
        const response = await import(
          `./assets/skins/${theme.components.decorativeDivider.skin}/divider.svg`
        );
        setIcon(() => response.default);
        return;
      }

      const { ReactComponent: ImportedIcon } = await import(
        `./assets/skins/${theme.components.decorativeDivider.skin}/divider.svg`
      );
      setIcon(() => ImportedIcon);
    };
    getIcon();
  }, [theme]);

  return theme.components.decorativeDivider.display ? (
    <S.Wrapper>
      {process.env.REACT_APP_ENV === 'cd' ? (
        <S.Divider>{Icon && <img src={Icon} />}</S.Divider>
      ) : (
        <S.Divider>{Icon && <Icon />}</S.Divider>
      )}
    </S.Wrapper>
  ) : null;
};

export default DecorativeDivider;
